import { FileExtensionEnum } from "../enums/file-extension.enum";
import { FileOption } from "../models/file-option.model";

export class ReportExportionSettings {
    Extension: FileExtensionEnum;
    ShowHeader: boolean;
    Delimiter?: string;
    CompressFile: boolean;
    Options = new Array<FileOption>();
}